<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <settings-tabs ></settings-tabs>
          <!-- /Settings Menu -->

          <div class="row" v-if="permissions.includes('General Settings')">
            <general-sidebar></general-sidebar>

            <div class="col-xl-9 col-lg-12">
              <!-- Settings Info -->
              <div class="card">
                <div class="card-body">
                  <div class="settings-header">
                    <!-- <h4>Profile Settings</h4> -->
                    <div>
                      <ul class="nav nav-tabs">
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: activeTab === 'profile' }"
                            @click="setActiveTab('profile')">
                            Profile Settings
                          </a>
                        </li>
                        <!-- <li class="nav-item">
                          <a class="nav-link" :class="{ active: activeTab === 'smtp' }" @click="setActiveTab('smtp')">
                            SMTP
                          </a>
                        </li> -->
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: activeTab === 'electricLookup' }" @click="setActiveTab('electricLookup')">
                            ELECTRALINK Settings
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
                  <div class="settings-form">
                    <Form v-if="activeTab === 'profile'" @submit="saveProfile" :validation-schema="schema">
                      <div class="settings-sub-header">
                        <h6>Employee Information</h6>
                        <p>Provide the information below</p>
                      </div>
                      <div class="form-wrap">
                        <div class="profile-upload">
                          <div class="profile-upload-img">
                            <span v-if="!imagePreview"><i class="ti ti-photo"></i></span>
                            <img v-if="imagePreview" :src="imagePreview" class="img-fluid" />
                            <button v-if="imagePreview" type="button" class="profile-remove" @click="removeImage">
                              <i class="feather-x"></i>
                            </button>
                          </div>
                          <div class="profile-upload-content">
                            <label class="profile-upload-btn">
                              <i class="ti ti-file-broken"></i> Upload Image
                              <input type="file" class="input-img" @change="handleImageUpload" />
                            </label>
                            <p>
                              JPG, JPEG or PNG. Max size of 2MB.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="profile-details">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                First Name <span class="text-danger">*</span>
                              </label>
                              <Field name="first_name" as="input" type="text" class="form-control"
                                v-model="form.first_name" />
                              <ErrorMessage name="first_name" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Last Name
                              </label>
                              <Field name="last_name" as="input" type="text" class="form-control"
                                v-model="form.last_name" />
                              <ErrorMessage name="last_name" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                User Name
                              </label>
                              <Field name="login_name" as="input" type="text" class="form-control"
                                v-model="form.login_name" />
                              <ErrorMessage name="login_name" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Phone Number
                              </label>
                              <Field name="phone_number" as="input" v-model="form.phone_number" type="text"
                                class="form-control" />
                              <span class="text-danger"
                                v-if="apiErrors && apiErrors['phone_number'] && apiErrors['phone_number'].length">{{
                                  apiErrors['phone_number'][0] }}</span>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Email</label>
                              <Field name="email" as="input" v-model="form.email" type="email" class="form-control"
                                disabled />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="profile-address">
                        <div class="settings-sub-header">
                          <h6>Address</h6>
                          <p>Please enter the address details</p>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Address
                              </label>
                              <Field name="address" as="input" type="text" class="form-control"
                                v-model="form.address" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-6">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Country
                              </label>
                              <select id="country_id" v-model="form.country_id" class="form-select">
                                <option value="">
                                  -----Select-----
                                </option>
                                <option v-for="res in Countries" :key="res" :value='res.id'>
                                  {{ res.country_name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-6">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                State / Province

                              </label>
                              <Field name="state_province" as="input" type="text" class="form-control"
                                v-model="form.state" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-6">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                City
                              </label>
                              <Field name="city" as="input" type="text" class="form-control" v-model="form.city" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-6">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Postal Code
                              </label>
                              <Field name="postal_code" as="input" type="text" class="form-control"
                                v-model="form.postal_code" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="submit-button text-end">
                        <!-- <a href="javascript:;" class="btn btn-light">Cancel</a> -->
                        <button type="submit" class="btn btn-primary">
                          Save Changes
                        </button>
                      </div>
                    </Form>

                    <Form v-if="activeTab === 'smtp'" @submit="saveSmtp" :validation-schema="smtpSchema" v-slot="{ resetForm, errors }">
                      <div class="profile-details">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Host <span class="text-danger">*</span>
                              </label>
                              <Field name="host" as="input" type="text" class="form-control" v-model="smtpForm.host" />
                              <ErrorMessage name="host" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Port <span class="text-danger">*</span>
                              </label>
                              <Field name="port" as="input" type="text" class="form-control" v-model="smtpForm.port" />
                              <ErrorMessage name="port" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Encryption <span class="text-danger">*</span>
                              </label>
                              <!-- <Field name="encryption" as="input" type="text" class="form-control"
                                v-model="smtpForm.encryption" /> -->
                              <Field as="select" name="encryption" class="form-select" v-model="smtpForm.encryption">
                                <option value="">
                                  ----select----
                                </option>
                                <option key="tls" value="tls">
                                  TLS
                                </option>
                                <option key="ssl" value="ssl">
                                  SSL
                                </option>
                                <option key="none" value="none">
                                  NONE
                                </option>
                              </Field>
                              <ErrorMessage name="encryption" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                User Name <span class="text-danger">*</span>
                              </label>
                              <Field name="username" as="input" v-model="smtpForm.username" type="text"
                                class="form-control" />
                              <ErrorMessage name="username" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Password <span class="text-danger">*</span></label>
                              <Field name="password" as="input" v-model="smtpForm.password" type="password"
                                class="form-control" />
                              <ErrorMessage name="password" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">From Name <span class="text-danger">*</span></label>
                              <Field name="from_name" as="input" v-model="smtpForm.from_name" type="text"
                                class="form-control" />
                              <ErrorMessage name="from_name" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">From Email <span class="text-danger">*</span></label>
                              <Field name="from_email" as="input" v-model="smtpForm.from_email" type="email"
                                class="form-control" />
                              <ErrorMessage name="from_email" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Default <span class="text-danger">*</span></label>
                              <!-- <Field name="is_default" as="input" v-model="smtpForm.is_default" type="text"
                                class="form-control" /> -->
                              <Field as="select" name="is_default" class="form-select" v-model="smtpForm.is_default">
                                <option value="">
                                  ----select----
                                </option>
                                <option key="1" value="1">
                                  True
                                </option>
                                <option key="0" value="0">
                                  False
                                </option>
                              </Field>
                              <ErrorMessage name="is_default" class="text-danger" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="submit-button text-end">
                        <button v-if="isReset" type="button" class="btn btn-light" @click="resetSmtp(resetForm)">
                          Reset
                        </button>
                        <button type="submit" class="btn btn-primary">
                          Save SMTP
                        </button>
                      </div>
                    </Form>

                    <!-- Electric Lookup Settings Tab -->
                    <div v-if="activeTab === 'electricLookup'">
                      <div class="settings-sub-header">
                        <h6>API Call</h6>
                      </div>
                      
                      <!-- Statistics Cards -->
                      <div class="row mb-4">
                        <div class="col-md-4">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Total</h5>
                              <h3 class="mb-0" v-if="!loadingStats">{{ apiStats.total }}</h3>
                              <div v-else class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Used</h5>
                              <h3 class="mb-0" v-if="!loadingStats">{{ apiStats.used }}</h3>
                              <div v-else class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Remaining</h5>
                              <h3 class="mb-0" v-if="!loadingStats">{{ apiStats.remaining }}</h3>
                              <div v-else class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- API Calls Table -->
                      <div class="row mt-4">
                        <div class="col-md-12">
                          <div class="table-container" v-if="!loadingHistory">
                            <a-table 
                              class="stripped table-hover" 
                              :columns="apiCallColumns" 
                              :data-source="tableData" 
                              :pagination="false"
                            >
                              <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'called_at'">
                                  {{ formatDate(record.called_at) }}
                                </template>
                                <template v-else-if="column.key === 'metadata'">
                                  <div class="metadata-display">
                                    <div v-if="record.metadata">
                                      <!-- <div v-if="record.metadata.url" class="mb-1">
                                        <strong>URL:</strong> {{ record.metadata.url }}
                                      </div> -->
                                      <div v-if="record.metadata.mpan" class="mb-1">
                                        <strong>MPAN:</strong> {{ record.metadata.mpan }}
                                      </div>
                                      <div v-if="record.metadata.type" class="mb-1">
                                        <strong>Type:</strong> {{ record.metadata.type }}
                                      </div>
                                      <!-- <div v-if="record.metadata.static !== undefined" class="mb-1">
                                        <strong>Static:</strong> {{ record.metadata.static ? 'Yes' : 'No' }}
                                      </div> -->
                                    </div>
                                    <span v-else class="text-muted">No metadata</span>
                                  </div>
                                </template>
                              </template>
                            </a-table>
                          </div>
                          
                          <!-- Pagination -->
                          <div class="pagination-container" v-if="tableData.length > 0 && !loadingHistory">
                            <a-pagination 
                              :current="pagination.current" 
                              :pageSize="pagination.pageSize" 
                              :total="pagination.total"
                              @change="handleTableChange" 
                              class="d-flex" 
                              showSizeChanger 
                              :pageSizeOptions="pageSizeOptions" 
                            />
                          </div>
                          <div v-if="loadingHistory" class="text-center py-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                          <div v-if="!loadingHistory && tableData.length === 0" class="text-center py-4 text-muted">
                            No API calls found
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Electric Lookup Settings Tab -->

                  </div>
                </div>
              </div>
              <!-- /Settings Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import { Form, Field, ErrorMessage, useForm } from "vee-validate";
import * as Yup from "yup";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      title: "Settings",
      activeTab: 'profile',
    };
  },

  watch: {
    activeTab(newTab) {
      // Fetch data when Electric Lookup tab is opened
      if (newTab === 'electricLookup') {
        // Functions from setup() are merged into component instance
        this.$nextTick(() => {
          if (this.fetchStatistics && this.fetchHistory) {
            this.fetchStatistics();
            this.fetchHistory();
          }
        });
      }
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const imagePreview = ref("");
    const apiErrors = ref(null);

    const isReset = ref(false)

    // Electric Lookup Settings
    const apiStats = ref({
      total: 0,
      used: 0,
      remaining: 0
    });

    const apiCalls = ref([]);
    const loadingStats = ref(false);
    const loadingHistory = ref(false);

    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });

    const pageSizeOptions = computed(() => {
      let options = [10];
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const tableData = computed(() => {
      return apiCalls.value.map((call, index) => ({
        key: call.id || index + 1,
        api_type: call.api_type || 'ElectricLookup',
        called_at: call.called_at,
        metadata: call.metadata
      }));
    });

    const fetchStatistics = async () => {
      loadingStats.value = true;
      try {
        const response = await store.dispatch('price/fetchElectricLookupStatistics');
        if (response) {
          apiStats.value = {
            total: response.total || 0,
            used: response.used || 0,
            remaining: response.remaining || 0
          };
        }
      } catch (error) {
        console.error('Error fetching statistics:', error);
        // Keep default values on error
      } finally {
        loadingStats.value = false;
      }
    };

    const fetchHistory = async (page = 1, pageSize = 10) => {
      loadingHistory.value = true;
      try {
        const response = await store.dispatch('price/fetchElectricLookupHistory', {
          page,
          pageSize
        });
        if (response) {
          // Handle different response structures
          if (response.data && Array.isArray(response.data)) {
            apiCalls.value = response.data;
            pagination.value.total = response.total || response.data.length;
          } else if (Array.isArray(response)) {
            apiCalls.value = response;
            pagination.value.total = response.length;
          } else {
            apiCalls.value = [];
            pagination.value.total = 0;
          }
        }
      } catch (error) {
        console.error('Error fetching history:', error);
        apiCalls.value = [];
        pagination.value.total = 0;
      } finally {
        loadingHistory.value = false;
      }
    };

    const apiCallColumns = ref([
      {
        title: "API Type",
        dataIndex: "api_type",
        key: "api_type",
        sorter: {
          compare: (a, b) => {
            a = a.api_type.toLowerCase();
            b = b.api_type.toLowerCase();
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      {
        title: "Called At",
        dataIndex: "called_at",
        key: "called_at",
        sorter: {
          compare: (a, b) => {
            return new Date(a.called_at) - new Date(b.called_at);
          },
        },
      },
      {
        title: "Metadata",
        dataIndex: "metadata",
        key: "metadata",
        sorter: false,
      },
    ]);

    const formatDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchHistory(current, pageSize);
    };


    const Countries = computed(() => store.getters['organisation/getCountries']);
    // const user = computed(() => store.getters['auth/user']);
    // const territories = computed(() => store.getters["users/getterritories"]);

    const permissions = computed(()=>{
      const user = store.getters['auth/user']
      return user.permissions;
  })
    const schema = Yup.object().shape({
      first_name: Yup.string()
        .required("First name is required")
    });

    const smtpSchema = Yup.object().shape({
      host: Yup.string()
        .required("Host is required"),
      port: Yup.number()
        .required("Port is required")
        .typeError("Port must be a number"),
      encryption: Yup.string()
        .required("Encryption type is required"),
      username: Yup.string()
        .required("Username is required"),
      password: Yup.string()
        .required("Password is required"),
      from_name: Yup.string()
        .required("From Name is required"),
      from_email: Yup.string()
        .email("Invalid email format")
        .required("From Email is required"),
      is_default: Yup.boolean()
        .required("Default status is required")
        .typeError("Default status must be true or false"),
    });



    const form = ref({
      id: null,
      image: null,
      first_name: '',
      last_name: '',
      login_name: '',
      email: '',
      phone_number: '',
      address: '',
      city: '',
      state: '',
      country_id: null,
      postal_code: '',
    });

    const smtpForm = ref({
      host: '',
      port: null,
      encryption: '',
      username: '',
      password: '',
      from_name: '',
      from_email: '',
      is_default: '',
      type:'user'
    })

    // if (user.value.image) {
    //   imagePreview.value = user.value.image;
    // }

    const saveProfile = async () => {
      if (form.value.id) {
        if (typeof form.value.image === 'string') {
          form.value.image = null;
        }
      }
      try {
        await store.dispatch('auth/updateProfile', form.value);
        // router.push('/');
        fetchUserData();
      } catch (error) {
        apiErrors.value = error.response.data.errors;
      }
    };

    const saveSmtp = async () => {
      try {
          const response = await store.dispatch('auth/updateSmtp', smtpForm.value);
          if(response.status){
            isReset.value = true
          }
      } catch (error) {
        console.log("error", error)
      }
    };

    const resetSmtp = async (resetForm) => {
      try {
        await store.dispatch('auth/resetSmtp', 'user');
        resetForm({
          values: {
            host: '',
            port: null,
            encryption: '',
            username: '',
            password: '',
            from_name: '',
            from_email: '',
            is_default: '',
            type: 'user'
          },
          errors: {},
          touched: {},
          dirty: false,
        })
        isReset.value = false
      } catch (error) {
        console.log("error", error)
      }
    };

    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.image = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target.result; // Show the image preview
        };
        reader.readAsDataURL(file); // Convert the file to a data URL
      }
    };

    const fetchUserData = async () => {
      const data = await store.dispatch('auth/fetchUser');
      Object.assign(form.value, data);
      imagePreview.value = data.image;
      const smtpData = await store.dispatch('auth/getSmtpUser');
      if(smtpData){
         isReset.value = true
      }
      Object.assign(smtpForm.value, smtpData)
    };

    const removeImage = () => {
      form.value.image = "";
      imagePreview.value = "";
    };

    onMounted(async () => {
      store.dispatch('organisation/fetchCountries');
      fetchUserData();
    });

    return {
      schema,
      fetchUserData,
      imagePreview,
      removeImage,
      form,
      saveProfile,
      handleImageUpload,
      Countries,
      apiErrors,
      smtpForm,
      saveSmtp,
      smtpSchema,
      permissions,
      resetSmtp,
      isReset,
      apiStats,
      apiCalls,
      formatDate,
      apiCallColumns,
      tableData,
      pagination,
      pageSizeOptions,
      handleTableChange,
      fetchStatistics,
      fetchHistory,
      loadingStats,
      loadingHistory,
    };
  },
};
</script>
<style>
.nav-tabs .nav-link{
  border: none !important;
}
.nav-tabs .nav-link.active{
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 3px solid red !important;
  color: red !important;
}

.metadata-display {
  font-size: 0.9rem;
}

.metadata-display div {
  word-break: break-word;
}

.card-title {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.card-body h3 {
  color: #333;
  font-weight: 600;
}
</style>
